import { render, staticRenderFns } from "./InfoMode.vue?vue&type=template&id=2256e696&"
import script from "./InfoMode.vue?vue&type=script&lang=js&"
export * from "./InfoMode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports